// extracted by mini-css-extract-plugin
export default {"load__btn":"styles_load__btn__jt0dT"};